import { render, staticRenderFns } from "./BHeader.vue?vue&type=template&id=7c89472f&scoped=true&"
import script from "./BHeader.vue?vue&type=script&lang=js&"
export * from "./BHeader.vue?vue&type=script&lang=js&"
import style0 from "./BHeader.vue?vue&type=style&index=0&id=7c89472f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89472f",
  null
  
)

export default component.exports